import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles((theme) => ({
    contentImage:{
        padding: 1 + "rem"
    }
}))

export default styles